// extracted by mini-css-extract-plugin
export default {"icon":"t63BB","link":"kFkTs","sizeInfo":"h2p2d"};